import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import { dateFormatter } from '../../../../../utils';

const TABLE_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.main?.name
  }
];

const STOCK_STATUS_HEADER = [
  {
    header: 'Batch No.',
    accessor: ''
  },
  {
    header: 'Exp Date',
    accessor: ''
  },
  {
    header: 'Stock',
    accessor: ''
  }
];

const PURCHASE_HISTORY_HEADER = [
  {
    header: 'Dated',
    accessor: (row) => dateFormatter(row?.createdAt)
  },
  {
    header: 'Supplier',
    accessor: 'supplier'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'MRP',
    accessor: 'mrp'
  },
  {
    header: 'Sales Price',
    accessor: 'sal_rate'
  }
];

export const VoucherSeriesSetupDetails = ({
  onClose,
  chargeType = 'opd_charges',
  doctorID,
  onAdd,
  isEditMode,
  editData
}) => {
  const [input, setInput] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [consignment, setConsignment] = useState([]);

  // Function to merge serviceDropdown and testDropdown data

  const methods = useForm();

  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const transformedValues = {
      ...formValues
    };
    console.log('HELLLO TRANSFORMED VALUES', transformedValues);
    onAdd(transformedValues);
    reset();
  };

  useEffect(() => {
    if (isEditMode && editData) {
      reset({
        prefix: editData.prefix,
        suffix: editData.suffix,
        start_transaction_no: editData.start_transaction_no,
        next_transaction_no: editData.next_transaction_no,
        valid_from_date: editData.valid_from_date,
        valid_to_date: editData.valid_to_date
      });
    } else {
      reset(); // Reset the form when not editing
    }
  }, [isEditMode, editData, reset]);

  useEffect(() => {
    if (!isEditMode) {
      reset();
    }
  }, [isEditMode, reset]);

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="0px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>

      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Box
          sx={{
            border: '0px solid gray',
            padding: 2,
            borderRadius: '8px',
            width: '100%',
            boxShadow: '0px 2px 10px #0099ff'
          }}
        >
          <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.7, fontWeight: 700, fontSize: '1.4rem' }}>Prefix</Typography>
              <TextField sx={{ flex: 0.8 }} name="prefix" placeholder="Enter Prefix" />
            </Stack>
            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.7, fontWeight: 700, fontSize: '1.4rem' }}>Suffix</Typography>
              <TextField sx={{ flex: 0.8 }} name="suffix" placeholder="Enter Suffix" />
            </Stack>
          </Stack>
          <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.7, fontWeight: 700, fontSize: '1.4rem' }}>Start Transaction No.</Typography>
              <TextField sx={{ flex: 0.8 }} name="start_transaction_no" placeholder="Start Transaction No." />
            </Stack>
            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.7, fontWeight: 700, fontSize: '1.4rem' }}>Next Transaction No.</Typography>
              <TextField sx={{ flex: 0.8 }} name="next_transaction_no" placeholder="Start Transaction No." />
            </Stack>
          </Stack>
          <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.7, fontWeight: 700, fontSize: '1.4rem' }}>Valid From Date</Typography>
              <TextField sx={{ flex: 0.8 }} name="valid_from_date" type="date" />
            </Stack>
            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.7, fontWeight: 700, fontSize: '1.4rem' }}>Valid To Date</Typography>
              <TextField sx={{ flex: 0.8 }} name="valid_to_date" type="date" />
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
            <Button variant="contained" type="submit">
              Add
            </Button>
            <Button variant="outlined" onClick={onClose} color="error">
              Close
            </Button>
          </Stack>
        </Box>
      </FormProvider>
    </Stack>
  );
};
